import { size } from '@floating-ui/react';
import { useMemo, useState } from 'react';
export const useFloatingSize = ({
  width,
  horizontalPadding
}) => {
  const [calculatedWidth, setCalculatedWidth] = useState(0);
  const sizeMiddleware = useMemo(() => {
    return size({
      apply({
        rects
      }) {
        setCalculatedWidth(rects.reference.width + (horizontalPadding ?? 0));
      }
    });
  }, [horizontalPadding]);
  if (width === 'REFERENCE') {
    return {
      calculatedWidth,
      sizeMiddleware
    };
  } else if (width === 'CONTENT') {
    return {};
  }
  return {
    calculatedWidth: width
  };
};